var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.49.283h-11A4.51 4.51 0 0 0 0 4.793v6.82a4.51 4.51 0 0 0 4.51 4.51.49.49 0 0 1 .49.49v2.17a1 1 0 0 0 1.53.78l4.47-3.26a1 1 0 0 1 .57-.18h3.89a4.51 4.51 0 0 0 4.54-4.51v-6.82a4.51 4.51 0 0 0-4.51-4.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10.303a.75.75 0 0 1-.75-.75v-.28a2.49 2.49 0 0 1 1.15-2.16.78.78 0 0 0 .4-.68.8.8 0 1 0-1.6 0 .75.75 0 0 1-1.5 0 2.3 2.3 0 1 1 3.46 2 1 1 0 0 0-.41.86v.28a.75.75 0 0 1-.75.73M10 12.503a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })));
};
export default SvgSupport;